/**
 * KBIテナントコードのバリデーションルール
 * 半角英数、記号(.@_-)を含む4~100文字以内
 * 例: tenant-001
 */
export default {
  validate(value: string | undefined | null): boolean {
    if (!value) {
      return true;
    }
    return /^[a-zA-Z0-9.@_-]{4,100}$/.test(value);
  },
};
